@if (options.length > 0) {
  <div class="input-grid input-grid-gaps">
    <app-select-input
      id="entity"
      [staticOptions]="options"
      [form]="form"
      [nameKey]="nameKey"
      [valueKey]="valueKey"
      class="fr-5">
      <ng-template #item let-data>
        {{ data | formatPerson }}
      </ng-template>
      <ng-template #selectedItem let-data>
        {{ data | formatPerson }}
      </ng-template>
    </app-select-input>
  </div>
  <app-action-buttons [primaryButtonLabel]="selectButtonLabel" [secondaryButtonLabel]="cancelButtonLabel"
  (primaryClickEvent)="submit()" (secondaryClickEvent)="hide()"></app-action-buttons>
} @else {
  <p>{{ noOptionsLabel | translate }}</p>
}

